export const messages = {
  en: {
    shopOrder: {
      title: 'Shop Order',
      productOrder: 'Product Order',
      groupOrder: 'Group Order',
      seckillOrder: 'Seckill Order',
      refundOrder: 'Refund Order',
      productName: 'Product Name',
      buyerName: 'Buyer Name',
      quantity: 'Quantity',
      amount: 'Amount',
      orderStatus: 'Order Status',
      createTime: 'Create Time',
      operation: 'Operation',
      groupBuyer: 'Group Leader/Buyer',
      groupCount: 'Group Count',
      groupPrice: 'Group Price',
      groupTime: 'Group Time',
      validityPeriod: 'Validity Period',
      seckillPrice: 'Seckill Price',
      purchaseTime: 'Purchase Time',
      deadline: 'Deadline',
      orderNumber: 'Order Number',
      refundReason: 'Refund Reason',
      applyTime: 'Apply Time',
      manage: 'Manage',
      detail: 'Detail'
    }
  },
  zh: {
    shopOrder: {
      title: '店铺订单',
      productOrder: '商品订单',
      groupOrder: '拼团订单',
      seckillOrder: '秒杀订单',
      refundOrder: '退款订单',
      productName: '商品名称',
      buyerName: '用户名称',
      quantity: '购买数量',
      amount: '金额',
      orderStatus: '订单状态',
      createTime: '创建时间',
      operation: '操作',
      groupBuyer: '团长/购买者',
      groupCount: '拼团人数',
      groupPrice: '拼团金额',
      groupTime: '拼团时间',
      validityPeriod: '有效期',
      seckillPrice: '秒杀金额',
      purchaseTime: '购买时间',
      deadline: '截止时间',
      orderNumber: '订单号',
      refundReason: '退款原因',
      applyTime: '申请时间',
      manage: '管理',
      detail: '详情'
    }
  }
}